import { getTopNavigationGroup } from '../../features/topNavigation';

export default getTopNavigationGroup;
